import React from 'react'
import { VStack, HStack, Box, Text, Badge } from '@chakra-ui/react'
import { useStores } from 'hooks/useStores'
import { observer } from 'mobx-react'
import PriorityUpdatesIcon from 'assets/icons/priority_updates.svg?react'
import BoltIcon from 'assets/icons/material-symbols_bolt-rounded.svg?react'
import { ITheme } from '../../../../interfaces/theme'
import DashboardSectionCard from '../DashboardSectionCard'

interface PriorityUpdateItem {
  id: number
  iconColor: string
  title: string
  description?: string
  badge: {
    text: string
    bgColor: string
  }
  author: string
  date: string
  isHighlighted?: boolean
}

const dummyData: PriorityUpdateItem[] = [
  {
    id: 1,
    iconColor: '#9B59B6',
    title: 'Side Orders Standard Operating Procedure',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempo...',
    badge: { text: '30 changes', bgColor: '#FFF4E6' },
    author: 'Trace Steffen',
    date: '09/20/2024'
  },
  {
    id: 2,
    iconColor: '#3498DB',
    title: 'Handbook for Excellent Ranch Operations',
    badge: { text: 'Review Process', bgColor: '#E3F2FD' },
    author: 'Trace Steffen',
    date: '09/20/2024',
  },
  {
    id: 3,
    iconColor: '#F1C40F',
    title: 'Side Orders Standard Operating Procedure',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempo...',
    badge: { text: '8 changes', bgColor: '#FFF4E6' },
    author: 'Trace Steffen',
    date: '09/20/2024'
  },
  {
    id: 4,
    iconColor: '#E91E63',
    title: 'Side Orders Standard Operating Procedure',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempo...',
    badge: { text: 'Review Work Plan', bgColor: '#FFF9C4' },
    author: 'Trace Steffen',
    date: '09/20/2024'
  },
  {
    id: 5,
    iconColor: '#E91E63',
    title: 'Side Orders Standard Operating Procedure',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempo...',
    badge: { text: '30 changes', bgColor: '#FFF4E6' },
    author: 'Trace Steffen',
    date: '09/20/2024'
  },
  {
    id: 6,
    iconColor: '#E91E63',
    title: 'Side Orders Standard Operating Procedure',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempo...',
    badge: { text: '15 changes', bgColor: '#FFF4E6' },
    author: 'Trace Steffen',
    date: '09/20/2024'
  }
]

const PriorityUpdatesView = () => {
  const { organizationStore } = useStores()
  const { organization } = organizationStore
  const currentTheme: ITheme = organization?.theme ?? {}

  const handleViewAll = () => {
    // TODO: Navigate to priority updates page
    console.log('View all priority updates')
  }

  return (
    <DashboardSectionCard
      icon={<PriorityUpdatesIcon width={24} height={24} />}
      title="Priority Updates"
      viewMoreLink={{
        label: 'View all',
        onClick: handleViewAll
      }}
      isEmpty={false}
      currentTheme={currentTheme}
    >
      <VStack spacing={0} alignItems="flex-start" alignSelf="flex-start" width="full">
        {dummyData.map((item) => (
          <Box
            key={item.id}
            width="full"
            padding="16px"
            bg={item.isHighlighted ? '#E3F2FD' : 'transparent'}
            _hover={{
              bg: item.isHighlighted ? '#BBDEFB' : 'gray.50'
            }}
            transition="background-color 0.2s"
            cursor="pointer"
          >
            <HStack spacing={3} alignItems="flex-start" width="full">
              <Box
                width="40px"
                height="40px"
                bg={item.iconColor}
                borderRadius="8px"
                display="flex"
                alignItems="center"
                justifyContent="center"
                flexShrink={0}
                css={{
                  '& svg path': {
                    fill: 'white !important'
                  }
                }}
              >
                <BoltIcon width={20} height={20} />
              </Box>
              <VStack spacing={1} alignItems="flex-start" flex={1} minWidth={0}>
                <Text
                  fontSize="16px"
                  fontWeight="600"
                  color={item.isHighlighted ? '#1976D2' : 'gray.800'}
                  lineHeight="24px"
                  marginBottom={0}
                  noOfLines={1}
                >
                  {item.title}
                </Text>
                {item.description && (
                  <Text
                    fontSize="14px"
                    color="gray.600"
                    lineHeight="20px"
                    marginBottom={0}
                    noOfLines={2}
                  >
                    {item.description}
                  </Text>
                )}
                <HStack spacing={2} alignItems="center" marginTop="4px">
                  <Badge
                    bg={item.badge.bgColor}
                    color="gray.700"
                    fontSize="12px"
                    fontWeight="500"
                    padding="2px 8px"
                    borderRadius="4px"
                  >
                    {item.badge.text}
                  </Badge>
                  <Text fontSize="12px" color="gray.500">
                    •
                  </Text>
                  <Text fontSize="12px" color="gray.500">
                    {item.author}
                  </Text>
                  <Text fontSize="12px" color="gray.500">
                    •
                  </Text>
                  <Text fontSize="12px" color="gray.500">
                    {item.date}
                  </Text>
                </HStack>
              </VStack>
            </HStack>
          </Box>
        ))}
      </VStack>
    </DashboardSectionCard>
  )
}

export default observer(PriorityUpdatesView)

